import React, { useEffect } from "react";
import { Button, CircularProgress } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import { actionCreators as ArchiveStoreActionCreators } from "../../../store/ArchiveStore";

interface Props {
  archiveIds: number[];
}

const FilePreviewLink = ({ archiveIds }: Props) => {
  const dispatch = useAppDispatch();
  const isLoadingArchiveItem = useAppSelector((state) => state.archive.isLoadingArchiveItem);
  const archiveItem = useAppSelector((state) => state.archive.archiveItem);
  const getArchiveItemAction = ArchiveStoreActionCreators.getArchiveItemById;
  const clearArchiveItem = ArchiveStoreActionCreators.clearArchiveItem;

  const handleClick = () => {
    dispatch(getArchiveItemAction(archiveIds[0]));
  };

  useEffect(() => {
    if (!archiveItem) return;

    try {
      const binaryData = atob(archiveItem.blob); // Decode
      const arrayBuffer = Uint8Array.from(binaryData, (char) => char.charCodeAt(0)); // Convert to byte
      const blob = new Blob([arrayBuffer], { type: "application/pdf" }); // Create blob object
      const blobUrl = URL.createObjectURL(blob);
      window.open(blobUrl, "_blank", "noopener,noreferrer");
    } catch (error) {
      console.error("Error generating or opening PDF Blob URL:", error);
    } finally {
      dispatch(clearArchiveItem());
    }
  }, [archiveItem]);

  return (
    <>
      {isLoadingArchiveItem ? (
        <CircularProgress size={16} />
      ) : (
        <Button
          onClick={handleClick}
          style={{
            textDecoration: "underline",
            color: "blue",
            background: "none",
            border: "none",
            cursor: "pointer",
          }}
        >
          {"Oversikt.pdf"}
        </Button>
      )}
    </>
  );
};

export default FilePreviewLink;
